import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import ConfirmationPopup from "../../components/common/ConfirmationPopup/ConfirmationPopup";
import RouterConstants from "../../constants/RouterConstants";
import { useLogEvents } from "../../hooks/useLogEvents";
import useSecureNavigate from "../../hooks/useSecureNavigate";
import { useAppStore } from "../../hooks/useStores";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import styles from "./NewTailoredGeneration.module.scss";

const NewTailoredGeneration = () => {
	const navigate = useSecureNavigate();
	const { t } = useTranslation("translation");
	const { logTailoredGenerationFigmaTabClick } = useLogEvents();
	const [isTrainingPopupOpen, setTrainingPopupOpen] = useState(false);
	const [shouldShowTrainingPopup, setShouldShowTrainingPopup] = useState(false);

	const { tgStore } = useAppStore();
	const { tgProjectStore, tgModelStore } = tgStore;

	useEffect(() => {
		tgProjectStore.getOrgProjects(1);
	}, []);

	useEffect(() => {
		if (tgModelStore.modelsList.length === 0) {
			tgModelStore
				.listAllModels()
				.then(() => {
					if (tgModelStore.modelsList.length === 0) {
						setShouldShowTrainingPopup(true);
					}
				})
				.catch((err) => {
					console.error("Failed to fetch training models", err);
				});
		}
	}, []);

	const handleStartTraining = () => {
		navigate(RouterConstants.NEW_TG.PROJECTS.fullPath);
		setTrainingPopupOpen(false);
	};

	const handleDemoTabClick = (e: React.MouseEvent) => {
		if (shouldShowTrainingPopup) {
			e.preventDefault();
			setTrainingPopupOpen(true);
		}
	};

	const subTabs: ITabLayout[] = [
		{ name: t("overview.tab"), link: RouterConstants.NEW_TG.OVERVIEW.path },
		{ name: t("projects.tab"), link: RouterConstants.NEW_TG.PROJECTS.path },
		{ name: t("api.tab"), link: RouterConstants.NEW_TG.API.path },
		{ name: t("iframe.tab"), link: RouterConstants.NEW_TG.IFRAME.path },
		{ name: t("figma.tab"), link: RouterConstants.NEW_TG.FIGMA.path, onClick: logTailoredGenerationFigmaTabClick },
		{ name: t("accessMethods.tab"), link: RouterConstants.NEW_TG.ACCESS_METHODS.path },
		{ name: t("demo.tab"), link: RouterConstants.NEW_TG.DEMO.path, onClick: handleDemoTabClick },
		{ name: t("bestPractices.tab"), link: RouterConstants.NEW_TG.BEST_PRACTICES.path },
	];

	return (
		<>
			<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={subTabs}>
				<Outlet />
			</TabsLayout>

			<ConfirmationPopup
				open={isTrainingPopupOpen}
				onClose={() => setTrainingPopupOpen(false)}
				title={t("trainingPopup.title")}
				description={t("trainingPopup.description")}
				confirmButtonText={t("trainingPopup.startTraining")}
				onClick={handleStartTraining}
				hideCancel
			/>
		</>
	);
};

export default observer(NewTailoredGeneration);
